export const DATA_GRID_PAGE_SIZE_OPTIONS = [10, 25, 50] as const;

export const DATA_GRID_INITIAL_PAGE_SIZE = 10;
